import R from 'ramda';
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import * as steps from 'common/steps';
import { appError } from 'application/applicationActions';
import * as dissertationInfoActions from './dissertationInfoActions';
import * as submissionActions from 'submission/submissionActions';

import {
  createAcknowledgeSubmissionEpic,
  createCompleteStepEpic,
  createLoadLocalStorageEpic,
  createSyncLocalStorageEpic,
} from 'common/stepEpicUtil';

import {
  fetchDegrees,
  fetchDepartments,
  fetchLicenseTypes,
} from 'common/stipAjax';

import {
  getFields,
  getCompleted,
  getLoadingInitData,
  getLoadingLocalStorage,
} from 'common/stepReducerUtil';

import { getActiveStep } from 'submission/submissionReducer';

const fetchInitData = () =>
  Observable.forkJoin(fetchDegrees(), fetchDepartments(), fetchLicenseTypes());

const fetchInitDataFilter = (state, action) => {
  const { dissertationInfo, submission } = state;
  const loadingLocalStorage = getLoadingLocalStorage(dissertationInfo);
  const loadingInitData = getLoadingInitData(dissertationInfo);
  const activeStep = getActiveStep(submission);

  return (
    loadingInitData &&
    activeStep === steps.DISSERTATION_INFO &&
    ((!loadingLocalStorage &&
      action.type === submissionActions.LOCAL_STORAGE_LOADED) ||
      (!loadingLocalStorage &&
        action.type === submissionActions.SET_ACTIVE_STEP) ||
      (!loadingLocalStorage &&
        action.type === submissionActions.INVALID_SUBMISSION) ||
      action.type === dissertationInfoActions.LOCAL_STORAGE_LOADED)
  );
};

const fetchInitDataEpic = (action$, store) =>
  action$
    .filter(action => fetchInitDataFilter(store.getState(), action))
    .mergeMap(() =>
      fetchInitData(store.getState())
        .map(([degrees, departments, licenseTypes]) =>
          dissertationInfoActions.initDataLoaded(
            degrees,
            departments,
            licenseTypes,
          ),
        )
        .catch(R.pipe(appError, Observable.of)),
    );

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    dissertationInfoActions.ADD_COMMITTEE_MEMBER,
    dissertationInfoActions.COMPLETE_STEP,
    dissertationInfoActions.DEGREE_CHANGED,
    dissertationInfoActions.DEPARTMENT_CHANGED,
    dissertationInfoActions.FIELD_CHANGED,
    dissertationInfoActions.LANGUAGE_CHANGED,
    dissertationInfoActions.LICENSE_TYPE_CHANGED,
    dissertationInfoActions.PRIMARY_CATEGORY_CHANGED,
    dissertationInfoActions.SECONDARY_CATEGORY_CHANGED,
    dissertationInfoActions.TERTIARY_CATEGORY_CHANGED,
  ],
  {
    completed: getCompleted,
    fields: getFields,
  },
  dissertationInfoActions.localStorageSynced,
  steps.DISSERTATION_INFO,
);

export default combineEpics(
  createLoadLocalStorageEpic(
    steps.DISSERTATION_INFO,
    dissertationInfoActions.localStorageLoaded,
  ),
  syncLocalStorageEpic,
  fetchInitDataEpic,
  createAcknowledgeSubmissionEpic(steps.DISSERTATION_INFO),
  createCompleteStepEpic(
    dissertationInfoActions.COMPLETE_STEP,
    steps.DISSERTATION_INFO,
  ),
);



// WEBPACK FOOTER //
// ./src/dissertation-info/dissertationInfoEpic.js